const localStorageKeys = {
  i18nextLng: "i18nextLng",
};

export default localStorageKeys;
